import React, { Component } from 'react';
import { Spin, Table, Button, Icon, Modal } from 'antd';
import { openNotification } from '../../../util/notificaciones';
import InventarioRequest from '../../../services/Inventario';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import InventarioBarrasRequest from '../../../services/InventarioBarras';
/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

export default class ReportDtlViews extends Component {
    state = {
        arrArticulosInventario: [],
        filterText: "",
        cargando: false,
        arrDrives: [],
        driveSelected: null,
        scroll: { x: '100%', y: 500 },
        bloquearBotones: false,
        paginacion: {},
        filtros: {
            filtro: undefined,
            page: undefined
        }
    }

    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.inventario !== prevProps.inventario) {
            if (this.props.inventario) {
                this.setState({ cargando: true }, () => {
                    InventarioRequest.ListarDetalleInventarioRpt(this.props.inventario?.id).then(response => {
                        state.cargando = false;
                        state.arrArticulosInventario = response.data
                        if (this.props.inventario?.es_editado && this.props.type === 'editar') {
                            openNotification(
                                'El inventario actual ya fue editado una vez, por lo tanto, no se podrá editar de nuevo.',
                                'Aviso'
                            )
                            state.bloquearBotones = true;
                        }
                        this.setState(state)
                    }).catch(err => {
                        this.setState({ cargando: false })
                        openNotification(
                            err?.response?.cuerpo,
                            err?.response?.titulo ?? 'Error'
                        )
                    })
                })
            }
        }
    }

    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.paginaSiguiente = paginaSiguiente
        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState({ cargando: true }, () => {
            InventarioRequest.ListarDetalleInventarioPT(this.props.inventario?.id, paginaSiguiente)
                .then(response => {
                    state.cargando = false;
                    state.arrArticulosInventario = response.data;
                    if (this.props.inventario?.es_editado && this.props.type === 'editar') {
                        openNotification(
                            'El inventario actual ya fue editado una vez, por lo tanto, no se podrá editar de nuevo.',
                            'Aviso'
                        )
                        state.bloquearBotones = true;
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        err?.response?.cuerpo,
                        err?.response?.titulo ?? 'Error'
                    )
                })
        })
    }

    exportExcel() {
        let today = new Date();
        const timestamp = today.getTime();
        let fileName = `Inventario_${this.props.inventario.centroSAP}_${this.props.inventario.FechaStr}_${timestamp}`

        // Ejemplo de uso:
        const datos = [];
        this.state.arrArticulosInventario.map((obj, index) => {
            datos.push({
                Fecha: this.props.inventario.FechaStr2,
                Refencia: this.props.inventario.Refencia,
                Drive: this.props.inventario.sitio,
                Codigo: obj.codigo,
                Articulo: obj.descripcion,
                Unidad: obj.unidad,
                Inicial: obj.inventarioInicial,
                Bodega: obj.conteoBodega,
                Cocina: obj.conteoCocina,
                Conteo: obj.conteo,
                Costo: obj.ult_costo,
                Diferencia: obj.diferencia,
                Sobrante: obj.diferencia > 0 ? (obj.diferencia * obj.ult_costo) : "",
                Faltante: obj.diferencia < 0 ? (obj.diferencia * obj.ult_costo) : "",
                Neto: obj.diferencia * obj.ult_costo
            })
        })

        // 1. Crear el libro y la hoja de trabajo
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Hoja1');
        // 2. Agregar columnas y filas de datos
        worksheet.columns =
            [
                { header: 'Fecha', key: 'Fecha', width: 12, style: { numFmt: '[$-c0a]dd"-"mm"-"yyyy', alignment: { horizontal: 'center' } } },
                { header: 'Inventario Número SAP', key: 'Refencia', width: 20 },
                { header: 'Nombre Caffenio', key: 'Drive', width: 25 },
                { header: 'Codigo', key: 'Codigo', width: 12 },
                { header: 'Articulo', key: 'Articulo', width: 45 },
                { header: 'Unidad', key: 'Unidad', width: 8 },
                { header: 'Inventario Inicial', key: 'Inicial', width: 13 },
                { header: 'Conteo Bodega', key: 'Bodega', width: 13 },
                { header: 'Conteo Cocina', key: 'Cocina', width: 13 },
                { header: 'Conteo', key: 'Conteo', width: 13 },
                { header: 'Ult Costo', key: 'Costo', width: 13, style: { numFmt: '$#,##0;[Red]-$#,##0' } },
                { header: 'Dif Unidad', key: 'Diferencia', width: 13 },
                { header: 'Sobrante', key: 'Sobrante', width: 13, style: { numFmt: '$#,##0;[Red]-$#,##0' } },
                { header: 'Faltante', key: 'Faltante', width: 13, style: { numFmt: '$#,##0;[Red]-$#,##0' } },
                { header: 'Neto', key: 'Neto', width: 13, style: { numFmt: '$#,##0;[Red]-$#,##0' } },
            ];
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getCell('A1').font = { bold: true };
        worksheet.getCell('B1').font = { bold: true };
        worksheet.getCell('C1').alignment = { horizontal: 'center' };
        worksheet.getCell('C1').font = { bold: true };
        worksheet.getCell('D1').alignment = { horizontal: 'center' };
        worksheet.getCell('D1').font = { bold: true };
        worksheet.getCell('E1').alignment = { horizontal: 'center' };
        worksheet.getCell('E1').font = { bold: true };
        worksheet.getCell('F1').alignment = { horizontal: 'center' };
        worksheet.getCell('F1').font = { bold: true };
        worksheet.getCell('G1').alignment = { horizontal: 'center' };
        worksheet.getCell('G1').font = { bold: true };
        worksheet.getCell('H1').alignment = { horizontal: 'center' };
        worksheet.getCell('H1').font = { bold: true };
        worksheet.getCell('I1').alignment = { horizontal: 'center' };
        worksheet.getCell('I1').font = { bold: true };
        worksheet.getCell('J1').alignment = { horizontal: 'center' };
        worksheet.getCell('J1').font = { bold: true };
        worksheet.getCell('K1').alignment = { horizontal: 'center' };
        worksheet.getCell('K1').font = { bold: true };
        worksheet.getCell('L1').alignment = { horizontal: 'center' };
        worksheet.getCell('L1').font = { bold: true };
        worksheet.getCell('M1').alignment = { horizontal: 'center' };
        worksheet.getCell('M1').font = { bold: true };
        worksheet.getCell('N1').alignment = { horizontal: 'center' };
        worksheet.getCell('N1').font = { bold: true };
        worksheet.getCell('O1').alignment = { horizontal: 'center' };
        worksheet.getCell('O1').font = { bold: true };

        /*
        
        // Set Column 3 to Currency Format
        worksheet.getColumn(6).numFmt = '$#,##0;[Red]-$#,##0';
        worksheet.getColumn(7).numFmt = '$#,##0;[Red]-$#,##0';
        //worksheet.getColumn(8).numFmt = '$#,##0;[Red]-$#,##0';
        */
        worksheet.addRows(datos);

        // 3. Escribir el workbook en un buffer (como un blob)
        workbook.xlsx.writeBuffer().then(r => {
            const buffer = r;
            // 4. Usar 'file-saver' para descargar el blob
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, fileName + '.xlsx');
        }).catch(err => {
            console.log(err)
            openNotification(
                "Ha ocurrido un error al generar el archivo de Excel.",
                "Error"
            )
        })
    }

    currencyFormat(num) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    financial(x) {
        return Number.parseFloat(x).toFixed(2);
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "articulo.codigo",
                key: "articulo.codigo",
                width: 20
            },
            {
                title: "Descripción",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion",
                width: 30
            },
            {
                title: "Unidad de almacenamiento",
                dataIndex: "articulo.unidad",
                key: "articulo.unidad",
                width: 20
            },
            {
                title: "Conteo",
                dataIndex: "conteo",
                key: "conteo",
                width: 20,
                render: (_, record) => (<div style={{ textAlign: "right", marginRight: 40 }}> <span>{this.financial(record.conteo)}</span> </div>)
            },
            {
                title: "Diferencia",
                dataIndex: "diferencia",
                key: "diferencia",
                width: 20,
                render: (_, record) => (<div style={{ textAlign: "right", marginRight: 40 }}> <span>{this.financial(record.diferencia)}</span> </div>)
            },
            {
                title: "Costo Variación",
                dataIndex: "costoVariacion",
                key: "costoVariacion",
                width: 25,
                render: (_, record) => (<div style={{ textAlign: "right", marginRight: 40 }}> <span>{this.currencyFormat(record.costoVariacion)}</span> </div>)
            }
        ]

        return (
            <div>
                <Modal
                    title={'Ver detalle de inventario'}
                    onCancel={() => this.props.esconderModal(false)}
                    visible={this.props.visible}
                    width={"95%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-editar-inventario-form"
                                className="btnCancelar"
                                key="back"
                                onClick={() => this.props.esconderModal(false)}
                            > Regresar </Button>
                        ]
                    }
                >
                    <div style={{ textAlign: "right", width: "100%" }}>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-guardar-inventario-modulo"
                            disabled={this.state.bloquear_guardar}
                            style={{marginBottom: 20}}
                            onClick={() => this.exportExcel()}
                        > Exportar Excel </Button>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulosInventario}
                            pagination={false}
                            scroll={this.state.scroll}
                        />
                    </Spin>
                </Modal>
            </div>
        )
    }

}